<template>
    <div id="financial-entities">
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Buró de Entidades Financieras</li>
      </template>
      <template slot="title">
        Buró de Entidades Financieras.
      </template>
      <template slot="body">
        <FEArea1></FEArea1>
      </template>
    </GenericPage>
    </div>
</template>

<script>
import FEArea1 from "@components/financial-entities/FEArea1";
import GenericPage from "./new-portal-views/GenericPage.vue"
export default {
    name: "financial-entities",
    components: {
        FEArea1,
        GenericPage
    }

}
</script>

<style>

</style>